import {Button, Divider, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import {useEffect, useState } from "react";
import InputWithBarcode from "../InputWithBarcode";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { AddIcon } from "@chakra-ui/icons";
import { BsFillBoxSeamFill } from "react-icons/bs";
import { NewProduct } from "../../pages/Inventory/components/Product";

interface SearchProductAfterBarCode {
  addNewProduct: (data: NewProduct) => void;
  addProduct: (data: NewProduct & { id: string }) => void;
};

const SearchProductAfterBarCode = (props: SearchProductAfterBarCode) => {
  const { t } = useTranslation("translations");

  const [barcode, setBarcode] = useState<string>("");
  const [product, setProduct] = useState<any>([]);
  const [loadingProducts, setLoadingProducts] = useState<boolean>(false);

  const searchProduct = async (code: string) => {
    setLoadingProducts(true);
    try {
      const res = await getAxiosInstance().get("/Products/Barcode/"+code);
      /**
       * @Info to modify the number of existing items that will be show modify the slice range
       */
      setProduct(res.data.slice(0, 3));
    } catch (e) {
      toast.warn(t("CAN_T_FIND_PRODUCT_WITH_BARCODE") as string, { position: "bottom-right" });
    } finally {
      setLoadingProducts(false);
    }
  }

  const addExistingProduct = (index: number) => {
    props.addProduct({
      id: product[index].id,
      name: product[index].name,
      sku: product[index].sku,
      unitMeasurementId: product[index].unitMeasurementId,
      barcode: product[index].barCodes[0].code,
      providerIds: [],
      categoriesIds: [],
      hasSerialNumber: product[index].hasSerialNumber,
      serialNumbers: product[index].serialNumbers,
    });
    setProduct([]);
    setBarcode("");
  }

  const addNewProduct = () => {
    props.addNewProduct({
      name: "",
      sku: "",
      unitMeasurementId: "",
      barcode: barcode,
      providerIds: [],
      categoriesIds: [],
      hasSerialNumber: false,
      serialNumbers: undefined
    });
    setProduct([]);
    setBarcode("");
  }

  useEffect(() => {
    if(barcode.length > 3) {
      searchProduct(barcode);
    }
  }, [barcode]);
  
  return (
    <div className="mt-4">
      <Text className="mb-1" fontWeight="semibold">{t('ADD_PRODUCT')}</Text>
      <Divider className="mb-4 mt-2" />
      <InputWithBarcode
        value={barcode}
        setValue={(data: string) => setBarcode(data)}
        placeholder={t("SCAN PRODUCT")}
      />
      <div className={`relative mt-2 ${loadingProducts ? "bg-red-200 opacity-40 pointer-events-none" : ""}`}>
        {
          loadingProducts &&
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <Spinner />
          </div>
        }

        {
          product.map((x: any, index: number) =>
              <Button
                key={`product-${index}`}
                variant="solid"
                colorScheme='teal'
                leftIcon={<BsFillBoxSeamFill />}
                width="100%"
                onClick={() => addExistingProduct(index)}
              >
                {x.name}
              </Button>
          )
        }

        {
          product.length === 0 && barcode.length > 3 &&
          <Button
            colorScheme="red"
            leftIcon={<AddIcon />}
            width="100%"
            onClick={() => addNewProduct()}
          >
            {t("REGISTER_NEW_PRODUCT")}
          </Button>
        }
      </div>
    </div>
  )
};

export default SearchProductAfterBarCode;